// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteMemberPermissions__divider-cb227c {
  height: 1px;
  display: flex;
  margin: 0 24px 24px 24px;
  box-sizing: border-box;
  background: var(--base-20);
}

.DeleteMemberPermissions__divider-footer-ebd3be {
  margin: 16px 24px;
}

.DeleteMemberPermissions__delete-button-fae859 {
  display: flex;
  align-items: center;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  padding: 12px 24px;
  cursor: pointer;
}

.DeleteMemberPermissions__delete-icon-dddd74 {
  margin-inline-end: 24px;
  fill: var(--color-text-secondary);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/Permissions/CallMemberPermissionsPopup/components/DeleteMemberPermissions/DeleteMemberPermissions.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,wBAAA;EACA,sBAAA;EACA,0BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,iCAAA;AACF","sourcesContent":[".divider {\n  height: 1px;\n  display: flex;\n  margin: 0 24px 24px 24px;\n  box-sizing: border-box;\n  background: var(--base-20);\n}\n\n.divider-footer {\n  margin: 16px 24px;\n}\n\n.delete-button {\n  display: flex;\n  align-items: center;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  padding: 12px 24px;\n  cursor: pointer;\n}\n\n.delete-icon {\n  margin-inline-end: 24px;\n  fill: var(--color-text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `DeleteMemberPermissions__divider-cb227c`,
	"divider-footer": `DeleteMemberPermissions__divider-footer-ebd3be`,
	"dividerFooter": `DeleteMemberPermissions__divider-footer-ebd3be`,
	"delete-button": `DeleteMemberPermissions__delete-button-fae859`,
	"deleteButton": `DeleteMemberPermissions__delete-button-fae859`,
	"delete-icon": `DeleteMemberPermissions__delete-icon-dddd74`,
	"deleteIcon": `DeleteMemberPermissions__delete-icon-dddd74`
};
module.exports = ___CSS_LOADER_EXPORT___;
